var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { ModalFooter, ModalHeader, SlideInModalPortal } from 'syf-component-library/ui/patterns/SlideInModalPortal';
import { useTranslation } from 'react-i18next';
import useRewards from '../../hooks/useRewards';
import { OwnRewardsClients } from '../../const/clients';
import RewardsModalContent from './ModalContent';
var RewardsModal = function (_a) {
    var _b, _c, _d, _e;
    var containerId = _a.containerId, modalTriggerId = _a.modalTriggerId, config = _a.config, isOpen = _a.isOpen, handleClose = _a.handleClose, goToRewardsPage = _a.goToRewardsPage;
    var t = useTranslation().t;
    var _f = useRewards(), clientId = _f.clientId, rewardsExperience = _f.rewardsExperience;
    var headerRef = useRef(null);
    var footerButtonLink = (_c = (_b = rewardsExperience === null || rewardsExperience === void 0 ? void 0 : rewardsExperience[clientId]) === null || _b === void 0 ? void 0 : _b.drawerActionButton) === null || _c === void 0 ? void 0 : _c.link;
    var footer = t(((_e = (_d = rewardsExperience === null || rewardsExperience === void 0 ? void 0 : rewardsExperience[clientId]) === null || _d === void 0 ? void 0 : _d.drawerActionButton) === null || _e === void 0 ? void 0 : _e.text) ||
        'modal.rewardsFooter');
    var title = t('modal.modalTitle');
    var handleRewardsFooter = function () {
        if (footerButtonLink) {
            handleClose(true);
            window.open(footerButtonLink, '_blank', 'noopener,noreferrer');
        }
        else {
            handleClose();
            goToRewardsPage();
        }
    };
    return (_jsx(SlideInModalPortal, __assign({ id: "rewards-slide-modal", containerId: containerId, isOpen: isOpen, modalTriggerId: modalTriggerId, "aria-labelledby": title, escapeModalHandler: function () { return handleClose(true); }, header: _jsx(ModalHeader, { closeModal: function () { return handleClose(true); }, content: title, "data-cy": "modal-header", dataType: "rewards snapshot", dataReason: "close", headerRef: headerRef }), footer: _jsx(ModalFooter, { dataCy: "modal-footer-button", dataPrimaryObject: "button", dataPrimaryType: "rewards snapshot", dataPrimaryReason: clientId in OwnRewardsClients
                ? 'Go To Rewards'
                : 'view full reward details', handlePrimaryButton: handleRewardsFooter, primaryText: footer }) }, { children: isOpen && _jsx(RewardsModalContent, { config: config }) })));
};
export default RewardsModal;
